import { render, staticRenderFns } from "./CampaignArticleList.vue?vue&type=template&id=0d3a2c06&scoped=true&"
import script from "./CampaignArticleList.vue?vue&type=script&lang=ts&"
export * from "./CampaignArticleList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3a2c06",
  null
  
)

export default component.exports